import { render, staticRenderFns } from "./MemberDetailCuratorLayout.vue?vue&type=template&id=410b4a2d&scoped=true&"
import script from "./MemberDetailCuratorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberDetailCuratorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b4a2d",
  null
  
)

export default component.exports